<!-- Young -->
<template>
  <div class="collect-device">
    <a-spin :spinning="rebootLoading" tip="设备正在重启中..." size="large">
      <public-bread-crumb :routes="routes" />
      <public-top-bar
        placeholder="请输入机构名称、固件版本、SN码"
        :topBarBtns="topBarBtns"
        :onTableSearchFun="onTableSearchFun"
        @changeBasicSearchFun="changeBasicSearchFun"
      />
      <public-table
        rowKey="sn"
        :columns="columns"
        :tableData="tableData"
        :tableInfo="tableInfo"
        :tableLoading="tableLoading"
        @selectTableRowFun="selectTableRowFun"
        @sortChangeFun="tableSorterFun"
      >
        <!-- 设备状态 -->
        <template slot="state" slot-scope="scope">
          <span :style="{ color: scope.row.state ? '#333' : '#red' }">{{
            scope.row.state ? "在线" : "离线"
          }}</span>
        </template>
        <!-- 故障监测 -->
        <template slot="instruc" slot-scope="scope">
          <span
            :style="{
              color: scope.row.instruc ? 'red' : '#5862cb'
            }"
            >{{ scope.row.instruc ? "异常" : "正常" }}</span
          >
        </template>
      </public-table>
      <a-modal
        v-model="modalShow"
        title="选择升级包"
        width="660px"
        class="update-modal"
        centered
        :closable="false"
      >
        <public-update
          type="访客设备"
          :updateServices="this.updateServices"
          :modalShow="modalShow"
          @closeUpdate="closeUpdate"
          @checkedVersion="checkedVersion"
        />
        <template slot="footer">
          <a-button
            key="back"
            type="primary"
            class="footer-btn"
            :loading="updateLoading"
            @click="updateMe"
            >确定</a-button
          >
          <a-button
            key="submit"
            @click="closeUpdate"
            class="footer-btn"
            style="margin-right: 0; background: #ecedff"
            >取消</a-button
          >
        </template>
      </a-modal>
      <public-status ref="statusWeight" />
    </a-spin>
  </div>
</template>

<script>
import { devicePublic, publicTableList } from "@/mixins/mixinsData";
import CoDServices from "@/services/collect.Device.services";
import DeviceServices from "@/services/deviceCommon.services";

export default {
  name: "CollectDevice",
  mixins: [devicePublic, publicTableList],
  data() {
    return {
      routes: [
        {
          name: "访客设备管理",
          path: "/collection-equipment"
        }
      ]
    };
  },
  computed: {
    // 监听属性 类似于data概念
  },
  watch: {
    // 监控data中的数据变化
  },
  mounted() {
    // 获取门禁设备列表
    this.getTableData(CoDServices.GetCoDTable);

    // 故障状态Api
    this.statusServices = "";
    // 重启设备Api
    this.rebootServices = DeviceServices.RebootDevices;

    // 升级Api
    this.updateServices = {
      listServices: DeviceServices.GetVersionTable,
      updateApi: DeviceServices.UpdateVersion
    };
  }
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
</style>
